import React, { useState } from 'react'
import PropTypes from 'prop-types'
import CardFinancial from '../CardFinancial/CardFinancial'
import {
  DropDownContainer,
  DropDownHeader,
  DropDownList,
  DropDownListContainer,
  ListItem,
  StyledArrow,
  StyledContainer,
  StyledContentFinancial,
  StyledRichText,
  StyledTabs,
  StyledTabTitle,
  StyledTabTitleContainer,
  StyledTitle,
} from './BlockFinancialResult.styled'
import FinancialVariantEnum from '../../enums/FinancialVariantEnum'
import useMediaQuery from '../../hooks/useMediaQuery'
import { deviceMax } from '../../theme/breakpoints'

const BlockFinancialResult = ({
  block,
  variant,
  className,
  parentPageNameForGtm,
}) => {
  const { blocDescription, blocTitle, financialTabs } = block
  const [isOpen, setIsOpen] = useState(false)

  const isMobile = useMediaQuery(deviceMax.mobileL)

  const sortedTabs = financialTabs.sort(
    (a, b) => Number(b.tabTitle) - Number(a.tabTitle)
  )

  const displayedTabs =
    variant === FinancialVariantEnum.investor
      ? sortedTabs.slice(0, 2)
      : sortedTabs

  const [activeTab, setActiveTab] = useState(displayedTabs[0])
  const availableYears = isMobile
    ? displayedTabs.slice(0, 4)
    : displayedTabs.slice(0, 5)
  const olderYears = isMobile ? displayedTabs.slice(4) : displayedTabs.slice(5)

  const changeActiveTab = (el) => {
    if (activeTab === el) return
    setIsOpen(false)
    return setActiveTab(el)
  }

  const toggling = () => setIsOpen(!isOpen)

  const onOptionClicked = (value) => () => {
    setActiveTab(value)
    setIsOpen(false)
  }

  const renderOlderYears = () => {
    if (olderYears.length === 1) {
      return (
        <StyledTabTitleContainer
          $active={olderYears[0] === activeTab}
          onClick={() => changeActiveTab(olderYears[0])}
        >
          <StyledTabTitle>{olderYears[0].tabTitle}</StyledTabTitle>
        </StyledTabTitleContainer>
      )
    } else
      return (
        <DropDownContainer $active={olderYears.includes(activeTab)}>
          <DropDownHeader
            $active={olderYears.includes(activeTab)}
            onClick={toggling}
          >
            {olderYears.includes(activeTab) ? activeTab.tabTitle : 'More'}
            <StyledArrow $isOpen={isOpen} />
          </DropDownHeader>
        </DropDownContainer>
      )
  }

  return (
    <StyledContainer className={className}>
      <StyledTitle>{blocTitle}</StyledTitle>
      {blocDescription?.blocDescription && (
        <StyledRichText>{blocDescription.blocDescription}</StyledRichText>
      )}
      <StyledTabs>
        {availableYears.map((el, index) => (
          <StyledTabTitleContainer
            key={index}
            $active={el === activeTab}
            onClick={() => changeActiveTab(el)}
          >
            <StyledTabTitle>{el.tabTitle}</StyledTabTitle>
          </StyledTabTitleContainer>
        ))}
        {olderYears.length > 0 && renderOlderYears()}
        {isOpen && (
          <DropDownListContainer>
            <DropDownList>
              {olderYears.map((option, index) => (
                <ListItem
                  $active={activeTab === option}
                  onClick={onOptionClicked(option)}
                  key={index}
                >
                  {option.tabTitle}
                </ListItem>
              ))}
            </DropDownList>
          </DropDownListContainer>
        )}
      </StyledTabs>
      {activeTab?.contents && (
        <StyledContentFinancial>
          {activeTab?.contents.map((card, index) => (
            <CardFinancial
              key={index}
              isMobile={isMobile}
              contents={card}
              parentPageNameForGtm={parentPageNameForGtm}
              variant={variant}
            />
          ))}
        </StyledContentFinancial>
      )}
    </StyledContainer>
  )
}

BlockFinancialResult.propTypes = {
  block: PropTypes.object,
  parentPageNameForGtm: PropTypes.string,
  variant: PropTypes.string,
}

export default BlockFinancialResult
